import ChevronDown from "@heroicons/react/solid/ChevronDownIcon"
import ChevronUp from "@heroicons/react/solid/ChevronUpIcon"
import ChevronRight from "@heroicons/react/solid/ChevronRightIcon"
import ChevronLeft from "@heroicons/react/solid/ChevronLeftIcon"
import Home from "@heroicons/react/solid/HomeIcon"
import Attachment from "@heroicons/react/solid/PaperClipIcon"
import Search from "@heroicons/react/solid/SearchIcon"
import Upload from "@heroicons/react/solid/UploadIcon"
import X from "@heroicons/react/solid/XIcon"
import Exclamation from "@heroicons/react/solid/ExclamationIcon"
import Pencil from "@heroicons/react/solid/PencilIcon"
import PencilAlt from "@heroicons/react/solid/PencilAltIcon"
import DocumentText from "@heroicons/react/outline/DocumentTextIcon"
import ExclamationCircle from "@heroicons/react/solid/ExclamationCircleIcon"
import Info from "@heroicons/react/solid/InformationCircleIcon"
import { HTMLAttributes } from "react"
import XCircle from "@heroicons/react/solid/XCircleIcon"
import LightBulb from "@heroicons/react/solid/LightBulbIcon"
import CheckCircle from "@heroicons/react/solid/CheckCircleIcon"
import CheckCircleOutline from "@heroicons/react/outline/CheckCircleIcon"
import ArrowLeft from "@heroicons/react/solid/ArrowLeftIcon"
import ArrowRight from "@heroicons/react/solid/ArrowRightIcon"
import ArrowUp from "@heroicons/react/solid/ArrowUpIcon"
import ArrowDown from "@heroicons/react/solid/ArrowDownIcon"
import { ReactComponent as Complete } from "../../assets/icons/complete.svg"
import { ReactComponent as Current } from "../../assets/icons/current.svg"
import { ReactComponent as Incomplete } from "../../assets/icons/incomplete.svg"
import { ReactComponent as Upcoming } from "../../assets/icons/upcoming.svg"
import { ReactComponent as Touched } from "../../assets/icons/touched.svg"
import { ReactComponent as Printer } from "../../assets/icons/printer.svg"
import { ReactComponent as Check } from "../../assets/icons/check.svg"
import { ReactComponent as InfoWrapped } from "../../assets/icons/info.svg"
import { ReactComponent as Alert } from "../../assets/icons/alert.svg"
import { ReactComponent as Trash } from "../../assets/icons/trash.svg"
import { ReactComponent as Spinner } from "../../assets/icons/spinner.svg"

export const ICON_LIBRARY = {
  Alert,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Attachment,
  Check,
  CheckCircle,
  CheckCircleOutline,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Complete,
  Current,
  DocumentText,
  Exclamation,
  ExclamationCircle,
  Home,
  Incomplete,
  Info,
  InfoWrapped,
  LightBulb,
  PaperClip: Attachment,
  Pencil,
  PencilAlt,
  Printer,
  Search,
  Touched,
  Trash,
  Upcoming,
  Upload,
  X,
  XCircle,
  Spinner,
}

export type IconLibraryKeys = keyof typeof ICON_LIBRARY

const getIcon = (variant: IconLibraryKeys) => {
  return ICON_LIBRARY[variant]
}

interface Props extends HTMLAttributes<HTMLSpanElement> {
  size?: "xs" | "sm" | "md" | "lg"
  wrapped?: true | false
  className?: string
  variant: IconLibraryKeys
}

export function Icon(props: Props) {
  const { size, variant, wrapped, className } = props
  const iconSizes = {
    xs: "0.75rem",
    sm: "1rem",
    md: "1.25rem",
    lg: "2rem",
  }
  const iconSize = iconSizes[size ?? "md"]
  const SelectedIcon = getIcon(variant)

  if (wrapped) {
    return (
      <div className={className}>
        <SelectedIcon
          width={iconSize}
          height={iconSize}
          className="overflow-visible"
        />
      </div>
    )
  }

  // had to spread the extra props, like `title`, to get them in. Weird..?
  return (
    <span
      {...props}
      aria-label={props["aria-label"] || `${variant} icon`}
      role="img"
    >
      <SelectedIcon
        width={iconSize}
        height={iconSize}
        className="overflow-visible"
      />
    </span>
  )
}
